import React from 'react'

const DonutChartLegend = ({data, total, colors}) => {
  return (
    <div>
    {
      data.map((d, index) => (
        <div key={index} className={`flex items-center ${index === data.length-1 ? '' : 'mb-2'} ${d.value === 0 ? 'opacity-25' : ''}`}>
          <div
            className="rounded-full mr-2"
            style={{minWidth: '12px', minHeight: '12px', background: d.value === 0 ? '#444': colors[data.length === colors.length ? index : index % colors.length ]}}
          />
          <div className="text-sm text-gray-444">
            {(d.value/total*100).toFixed(0)}% - {d.name} ({d.value})
          </div>
        </div>
      ))
    }
    </div>
  )
}

export { DonutChartLegend }
